import React, { useState } from 'react';
import SimpleBanner from '../components/SimpleBanner';
import aboutBg from '../assets/About.jpg';

const PrivacyPolicy = () => {
  const [openSections, setOpenSections] = useState({});

  const toggleSection = (sectionId) => {
    setOpenSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }));
  };

  const styles = `
    /* Google Fonts Import - Add this to your main CSS file or index.html <head> for production */
    @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600&family=Playfair+Display:wght@400&display=swap');

    /* Global body styles for white background */
    body {
        background-color: white;
        margin: 0;
        padding: 0;
    }

    /* Styles for the container of the dropdowns and text below the banner */
    .privacy-policy-container {
        font-family: 'Open Sans', sans-serif;
        max-width: 800px; /* Default max-width for content */
        width: 100%; /* Full width on smaller screens */
        margin: 40px auto;
        padding: 0 20px; /* Padding for content inside the container */
        line-height: 1.6;
        color: #666666;
        box-sizing: border-box;
    }

    /* Responsive adjustment for larger screens */
    @media (min-width: 992px) { /* Adjust breakpoint as needed for "large screen" */
        .privacy-policy-container {
            max-width: 85%; /* 85% width on large screens */
            width: 85%;
        }
    }

    /* Styles for the Effective Date text - Responsive Font Size */
    .effective-date-text {
        font-family: 'Open Sans', sans-serif;
        font-weight: 600;
        font-size: clamp(18px, 3vw, 24px); /* Responsive font size */
        line-height: 100%;
        letter-spacing: 0%;
        text-align: center;
        text-transform: uppercase;
        color: #D6A54F;
        margin: 40px auto 20px auto;
        max-width: 800px;
        padding: 0 20px;
        display: block;
        box-sizing: border-box;
    }
    @media (min-width: 992px) {
        .effective-date-text {
            max-width: 85%;
            width: 85%;
        }
    }

    /* Styles for the introductory paragraph - Responsive Font Size */
    .intro-paragraph {
        font-family: 'Open Sans', sans-serif;
        font-weight: 300;
        font-size: clamp(16px, 2.5vw, 20px); /* Responsive font size */
        line-height: 35px;
        letter-spacing: 0%;
        text-align: center;
        color: #666666;
        margin: 0 auto 30px auto;
        max-width: 800px;
        padding: 0 20px;
        box-sizing: border-box;
    }
    @media (min-width: 992px) {
        .intro-paragraph {
            max-width: 85%;
            width: 85%;
        }
    }

    .intro-paragraph a {
        font-family: 'Open Sans', sans-serif;
        font-weight: 300;
        font-size: inherit; /* Inherit from parent for responsive scaling */
        line-height: inherit;
        letter-spacing: inherit;
        text-align: center;
        text-decoration: underline;
        text-decoration-style: solid;
        text-decoration-offset: 0%;
        text-decoration-thickness: 1px;
        text-decoration-skip-ink: auto;
        color: #007bff;
    }

    /* Dropdown Section Styles */
    .section {
        margin-bottom: 15px;
        padding: 0;
        overflow: hidden;
    }

    .section-title {
        font-family: 'Playfair Display', serif;
        font-weight: 400;
        font-size: clamp(20px, 3vw, 20px); /* Responsive font size */
        line-height: 60px; /* Adjust as needed with new font size */
        letter-spacing: 0%;
        color: #121212;
        margin: 0;
        padding: 0 0px 10px 0px; /* Added bottom padding for line */
        display: flex; /* Use flexbox for alignment of text and arrow */
        align-items: center; /* Vertically align text and arrow */
        justify-content: space-between;
        cursor: pointer;
        border-bottom: 1px solid #ccc; /* Line after heading */
    }

    .section-title:hover {
        /* No hover background as per design */
    }

    /* New CSS for the SVG arrow icon */
    .arrow-icon {
        width: 1.2em; /* Matches the old font-size of the arrow span */
        height: 1.2em; /* Matches the old font-size of the arrow span */
        color: #888; /* Matches the old color */
        transition: transform 0.3s ease-in-out; /* Matches the old transition */
        margin-left: 10px; /* Optional: add spacing if needed */
        flex-shrink: 0; /* Prevents icon from shrinking on smaller screens */
    }

    .arrow-icon.rotate {
        transform: rotate(180deg);
    }

    .section-content {
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.3s ease-out, padding 0.3s ease-out;
        padding: 0 0px;
        background-color: transparent;
    }

    .section-content.open {
        max-height: 1000px;
        padding: 15px 0px;
    }

    .section ul {
        list-style: none;
        margin: 0;
        padding: 0; /* Keep this at 0, li will handle its own padding */
    }

    .section ul li {
        margin-bottom: 10px;
        padding-left: 25px; /* This padding creates the space for the bullet and hanging indent */
        position: relative; /* Essential for absolute positioning of ::before */
        font-family: 'Open Sans', sans-serif;
        font-weight: 400;
        font-size: clamp(14px, 2vw, 16px); /* Responsive font size */
        line-height: clamp(20px, 3.5vw, 28px); /* Responsive line height for list items */
        letter-spacing: 0%;
        color: #666666;
    }

    .section ul li::before {
        content: "•";
        color: #000000; /* Bullet point color black */
        font-weight: bold;
        position: absolute; /* Changed to absolute */
        left: 10px; /* Adjust this value to position the bullet */
        top: 0; /* Align with the top of the line-height */
    }

    .section p {
        margin-bottom: 10px;
        font-family: 'Open Sans', sans-serif;
        font-weight: 400;
        font-size: clamp(14px, 2vw, 16px); /* Responsive font size */
        line-height: clamp(20px, 3.5vw, 28px); /* Responsive line height for paragraphs */
        letter-spacing: 0%;
        color: #666666;
    }

    .section p strong {
        font-weight: 600;
        font-size: inherit; /* Inherit for consistent scaling */
        line-height: inherit;
    }

    /* Contact Info Specific Styling - Responsive Font Size */
    .contact-info {
        font-family: 'Open Sans', sans-serif;
        font-weight: 400;
        font-size: clamp(14px, 2vw, 16px); /* Responsive font size */
        line-height: clamp(20px, 3.5vw, 28px); /* Responsive line height */
        letter-spacing: 0%;
        color: #666666; /* Set the desired color for the non-link text */
    }

    .contact-info a {
        font-family: 'Open Sans', sans-serif;
        font-weight: 400;
        font-size: inherit; /* Inherit for consistent scaling */
        line-height: inherit;
        letter-spacing: inherit;
        text-decoration: none; /* REMOVE UNDERLINE */
        color: inherit; /* Inherit color from parent (.contact-info), which is #666666 */
        cursor: pointer;
    }
  `;

  return (
    <>
      <style>{styles}</style>

      {/* SimpleBanner component */}
      <SimpleBanner bgImage={aboutBg} headingText="Privacy Policy" />

      {/* Effective Date and Intro Paragraph */}
      <p className="effective-date-text">Effective Date: June 13, 2025</p>

      <p className="intro-paragraph">
        The Porch Cafe & Restaurant (“we”, “us”, “our”) is committed to protecting your privacy. This policy explains how we collect, use,
        and safeguard your information when you use our website <a href="https://admin.theporch.in" target="_blank" rel="noopener noreferrer">https://admin.theporch.in</a>, contact us, or place a reservation/order.
      </p>

      {/* Main Privacy Policy Container with Dropdowns */}
      <div className="privacy-policy-container">
        {/* Information We Collect Section */}
        <section className="section">
          <h3
            className={`section-title ${openSections['infoCollect'] ? 'open' : ''}`}
            onClick={() => toggleSection('infoCollect')}
          >
            Information We Collect
            <svg
              className={`arrow-icon ${openSections['infoCollect'] ? 'rotate' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </h3>
          <div className={`section-content ${openSections['infoCollect'] ? 'open' : ''}`}>
            <ul>
              <li><strong>Personal Data:</strong> Name, contact number, email, reservation or order details.</li>
              <li><strong>Technical Data:</strong> IP address, browser type, device data, pages visited — collected via cookies and analytics tools.</li>
              <li><strong>Order or Reservation Details:</strong> Preferences, timings, special requests when submitted via online forms.</li>
            </ul>
          </div>
        </section>

        {/* How We Use Your Information Section */}
        <section className="section">
          <h3
            className={`section-title ${openSections['howUse'] ? 'open' : ''}`}
            onClick={() => toggleSection('howUse')}
          >
            How We Use Your Information
            <svg
              className={`arrow-icon ${openSections['howUse'] ? 'rotate' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </h3>
          <div className={`section-content ${openSections['howUse'] ? 'open' : ''}`}>
            <ul>
              <li>To confirm reservations, respond to inquiries, and manage table bookings.</li>
              <li>To improve your experience by tracking site performance and usage.</li>
              <li>To occasionally share offers, updates, or event details via email or SMS (only with your consent).</li>
            </ul>
          </div>
        </section>

        {/* Data Sharing and Disclosure Section */}
        <section className="section">
          <h3
            className={`section-title ${openSections['dataSharing'] ? 'open' : ''}`}
            onClick={() => toggleSection('dataSharing')}
          >
            Data Sharing and Disclosure
            <svg
              className={`arrow-icon ${openSections['dataSharing'] ? 'rotate' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </h3>
          <div className={`section-content ${openSections['dataSharing'] ? 'open' : ''}`}>
            <p className="data-sharing-intro-text">
                Your data is <strong>never sold or misused</strong>.
            </p>
            <ul>
              <li>Limited data may be shared with third-party partners (e.g.SMS/Email platforms) for functionality or promotional campaigns.</li>
              <li>We may disclose information when required by law or regulation.</li>
            </ul>
          </div>
        </section>

        {/* Data Security Section */}
        <section className="section">
          <h3
            className={`section-title ${openSections['dataSecurity'] ? 'open' : ''}`}
            onClick={() => toggleSection('dataSecurity')}
          >
            Data Security
            <svg
              className={`arrow-icon ${openSections['dataSecurity'] ? 'rotate' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </h3>
          <div className={`section-content ${openSections['dataSecurity'] ? 'open' : ''}`}>
            <p>
              We use encryption and secure data practices. Payments, if any, are handled by third-party secure
              gateways.
            </p>
          </div>
        </section>

        {/* Cookies Section */}
        <section className="section">
          <h3
            className={`section-title ${openSections['cookies'] ? 'open' : ''}`}
            onClick={() => toggleSection('cookies')}
          >
            Cookies
            <svg
              className={`arrow-icon ${openSections['cookies'] ? 'rotate' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </h3>
          <div className={`section-content ${openSections['cookies'] ? 'open' : ''}`}>
            <p>
              Cookies help us enhance your experience. You may disable cookies in your browser settings if
              preferred.
            </p>
          </div>
        </section>

        {/* Your Rights Section */}
        <section className="section">
          <h3
            className={`section-title ${openSections['yourRights'] ? 'open' : ''}`}
            onClick={() => toggleSection('yourRights')}
          >
            Your Rights
            <svg
              className={`arrow-icon ${openSections['yourRights'] ? 'rotate' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </h3>
          <div className={`section-content ${openSections['yourRights'] ? 'open' : ''}`}>
            <ul>
              <li>You may access, correct, or request deletion of your data anytime.</li>
              <li>You can opt out of marketing communications by writing to us.</li>
            </ul>
          </div>
        </section>

        {/* Updates Section (general updates) */}
        <section className="section">
          <h3
            className={`section-title ${openSections['updates1'] ? 'open' : ''}`}
            onClick={() => toggleSection('updates1')}
          >
            Updates
            <svg
              className={`arrow-icon ${openSections['updates1'] ? 'rotate' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </h3>
          <div className={`section-content ${openSections['updates1'] ? 'open' : ''}`}>
            <p>
              We may update this policy from time to time. The latest version will always reflect the current
              effective date.
            </p>
          </div>
        </section>

        {/* Contact Us Section */}
        <section className="section">
          <h3
            className={`section-title ${openSections['contactUs'] ? 'open' : ''}`}
            onClick={() => toggleSection('contactUs')}
          >
            Contact Us
            <svg
              className={`arrow-icon ${openSections['contactUs'] ? 'rotate' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </h3>
          <div className={`section-content ${openSections['contactUs'] ? 'open' : ''}`}>
            <p className="contact-info">
              Rooftop Area, Hotel The Pride, 267, Rajeev Gandhi Nagar, Kota - 324005<br />
              <a href="mailto:info@theporchcafe.in">info@theporchcafe.in</a><br />
              <a href="tel:+919024283004">+91 902 428 3004</a> | <a href="tel:+919602679997">+91 960 267 9997</a>
            </p>
          </div>
        </section>
      </div>
    </>
  );
};

export default PrivacyPolicy;